// extracted by mini-css-extract-plugin
export default {"mobileCard":"CategoryPreview_mobileCard__5kYhn","desktopCard":"CategoryPreview_desktopCard__+oNl9","categoryPreviewCardWrapper":"CategoryPreview_categoryPreviewCardWrapper__NwALU"};